<template>
  <div>
    <div class="container">
      <!-- 編集画面の上部メニュー -->
      <Header class="header--trim">
        <template #title>背景切り取り</template>
        <template #menu>
          <!-- ベースイラスト選択画面へ戻る -->
          <router-link to="/select">
            <CancelButton class="header-btn reselect-img">戻る</CancelButton>
          </router-link>
          <!-- Twitterアカウント切り替えアラートダイアログ -->
          <button
            id="alert_open-twitter"
            class="twitter-icon"
            type="button"
          ></button>
          <!-- 完了ボタン -->
          <EnterButton
            class="header-btn btn-complete"
            @click="onClickCompleteBtn"
          >
            決定
          </EnterButton>
        </template>
      </Header>

      <!-- トリミングエリア -->
      <div class="trimming-area">
        <!-- 〓ピンチイン／アウト、もしくはでスライダーを左右に動かして、ベースイラストを拡縮〓 -->
        <!-- 〓ドラッグでベースイラスト移動〓 -->
        <canvas
          id="trimImageCanvas"
          width="750"
          height="1200"
          style="background: black"
          :data-src="canvasImgSrc"
        >
        </canvas>
        <div class="sliderBox">
          <div class="size-slider">
            <input id="zoom-slider" type="range" name="scale" />
            <span class="size-slider__zoom-out">-</span>
            <span class="size-slider__zoom-in">+</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, onMounted, onUnmounted } from "vue";
import { useRouter } from "vue-router";
import { useGlobalStore } from "@/stores/global";
import Trim from "@/javascripts/image/trim";
import EnterButton from "@/components/EnterButton.vue";
import CancelButton from "@/components/CancelButton.vue";
import Header from "@/components/Header.vue";

export default defineComponent({
  name: "Trim",
  components: {
    EnterButton,
    CancelButton,
    Header,
  },
  setup() {
    const router = useRouter();
    const toSelect = () => router.push({ name: "select" });
    const toEdit = () => router.push({ name: "edit" });

    const trim = new Trim();

    const { imageEditor } = useGlobalStore();
    const selectedImage = imageEditor.selectedImage;
    if (!selectedImage) {
      toSelect();
      return;
    }
    let canvasImgSrc = "";
    if (imageEditor.isSelectedImageUploaded()) {
      canvasImgSrc = selectedImage.src as string;
    } else {
      const canvasImgName = selectedImage.fileName;
      canvasImgSrc = "/app/assets/img/base_illust/original/" + canvasImgName;
    }

    onMounted(() => {
      trim.setupView();
    });

    onUnmounted(() => {});

    /**
     * 完了ボタン押下時の処理
     */
    function onClickCompleteBtn() {
      trim.barragePreventAll();
      trimImage();
      toEdit();
    }

    function trimImage() {
      const points = trim.getTrimmingAreaBottomPoints();
      const scale = trim.getTrimmingScale();
      const trimPoint = { x: points.x, y: points.y, scale: scale };
      imageEditor.trimImage(trimPoint);
    }

    return {
      toSelect,
      onClickCompleteBtn,
      canvasImgSrc,
    };
  },
});
</script>

<style scoped>
@import "/app/assets/css/style.css";

.header--trim {
  height: 160px;
}
</style>
